"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableRow
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
var KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
var material_1 = require("@mui/material");
var commonTypes_1 = require("../../shared/types/commonTypes");
var crude_selector_1 = require("../../store/crude/crude.selector");
var DataTableCell_1 = __importDefault(require("../DataTableView/DataTableCell"));
var DataTableActions_1 = __importDefault(require("../DataTableView/DataTableActions"));
var react_router_1 = require("react-router");
var crudeHooks_1 = require("../../crudeHooks");
var styles_1 = require("@mui/material/styles");
var styles_2 = require("@mui/styles");
var isListLevelAvailable_1 = __importDefault(require("../../shared/util/isListLevelAvailable"));
var getCrudeEntityColumns_1 = __importDefault(require("../../shared/util/getCrudeEntityColumns"));
var getTableColumns_1 = __importDefault(require("../../shared/util/getTableColumns"));
var DataTableView_1 = __importDefault(require("../DataTableView/DataTableView"));
var react_i18next_1 = require("react-i18next");
var useStyles = styles_2.makeStyles(function (theme) { return ({
    mobileTableNavigation: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center',
    },
    actions: {
        padding: '6px 16px',
        backgroundColor: 'inherit',
    },
}); });
var DataResponsiveRow = function (props) {
    var _a, _b;
    var history = react_router_1.useHistory();
    var classes = useStyles();
    var context = react_1.useContext(crudeHooks_1.CrudeContext);
    var theme = styles_1.useTheme();
    var t = react_i18next_1.useTranslation().t;
    var crudePath = react_redux_1.useSelector(crude_selector_1.getCrudePath) || '';
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var showCollapse = react_redux_1.useSelector(crude_selector_1.getShowCollapse);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var maxResponsiveTableColumns = appLayout.maxResponsiveTableColumns;
    // manage Licenses
    var configurableTableLicense = props.treeViewLevel === 0 ? crudeLicense.configurableTable.available : false;
    var treeViewLicense = crudeLicense.treeView.available;
    var integratedHTMLLicense = crudeLicense.integratedHTML.available;
    var crudeHookProps = context.crudeHookProps;
    var TableActionElement = crudeHookProps && crudeHookProps.tableActionComponent;
    var sharedData = crudeHookProps && crudeHookProps.sharedData;
    var entity = props.entity;
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var maxTreeViewLevel = appLayout.maxTreeViewLevel || 1;
    var _c = react_1.useState(isListLevelAvailable_1.default(treeViewLicense, dataDisplayMode, maxTreeViewLevel, props.treeViewLevel)), listLevelAvailable = _c[0], setListLevelAvailable = _c[1];
    react_1.useEffect(function () {
        setListLevelAvailable(isListLevelAvailable_1.default(treeViewLicense, dataDisplayMode, maxTreeViewLevel, props.treeViewLevel));
    }, [props.treeViewLevel]);
    var _d = react_1.default.useState(false), openTreeView = _d[0], setOpenTreeView = _d[1];
    var _e = react_1.default.useState(false), openAdditionalColumns = _e[0], setOpenAdditionalColumns = _e[1];
    var _f = react_1.default.useState(crudeSchema ? getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity) : []), entityColumns = _f[0], setEntityColumns = _f[1];
    react_1.useEffect(function () {
        if (!showCollapse) {
            setOpenTreeView(false);
        }
    }, [showCollapse]);
    var entityReference = '';
    var sourceColumn = '';
    var joinEntity = null;
    if (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference) {
        entityReference = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference.sourceEntity;
        sourceColumn = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference.sourceColumn;
        if (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference.manyToManyOppositeEntityName) {
            entityReference = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference.manyToManyOppositeEntityName;
            joinEntity = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference.sourceEntity;
        }
    }
    var embeddingEntityFilter = {
        name: entityReference,
        key: sourceColumn,
        value: props.id,
    };
    if (joinEntity) {
        embeddingEntityFilter.joinEntity = joinEntity;
    }
    var onClickEntity = function (id) {
        // edit im embedded mode oder in eigenem Fenster per Click
        // zunächst wird aber die treeview eingeklappt
        if (typeof (props.treeViewLevel) === 'number' && props.treeViewLevel < 1) {
            if (appLayout.embeddedEditFormMainLevel) {
                if (openTreeView) {
                    setOpenTreeView(false);
                }
                if (props.stickyCell && props.tableRef && props.tableRef.current && props.tableRef.current.parentElement) {
                    props.tableRef.current.parentElement.scrollTo(0, 0);
                }
            }
            else {
                props.editView && props.editView({
                    entity: entity,
                    id: props.id,
                    treeViewLevel: (props.treeViewLevel || 0) + 1,
                });
                var newPath = crudePath + "/" + props.entity + "/" + id;
                history.push(newPath);
            }
        }
        else {
            if (appLayout.embeddedEditFormHigherLevel) {
                if (openTreeView) {
                    setOpenTreeView(false);
                }
            }
            else {
                props.editView && props.editView({
                    entity: entity,
                    id: props.id,
                    treeViewLevel: (props.treeViewLevel || 0) + 1,
                });
            }
        }
    };
    var StyledTableRow = material_1.styled(material_1.TableRow)(function (_a) {
        var theme = _a.theme;
        return ({
            '&:nth-of-type(odd)': {
                backgroundColor: openTreeView ? theme.palette.background.default : theme.palette.background.default,
                borderBottom: "1px solid " + theme.palette.grey.A400,
            },
            '&:nth-of-type(even)': {
                backgroundColor: openTreeView ? theme.palette.background.paper : theme.palette.background.paper,
                borderBottom: "1px solid " + theme.palette.grey.A400,
            },
        });
    });
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var tableRowData = props.data.data.find(function (rowObject) { return (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn) && rowObject[entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn] === props.id; });
    var Row = react_1.default.useMemo(function () {
        var columnCounter = 0;
        var additionalColumns = false;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledTableRow, { key: "DataTableRow" + props.id },
                react_1.default.createElement("td", null,
                    entityColumns.map(function (column) {
                        var _a;
                        if (!column.hideInTableView) {
                            if (!((maxResponsiveTableColumns && columnCounter < maxResponsiveTableColumns) || !maxResponsiveTableColumns)) {
                                additionalColumns = true;
                            }
                            var entityColumn = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(function (col) { return col.name === column.name; });
                            if (column.name !== 'crudeAction') {
                                columnCounter += 1;
                                return (react_1.default.createElement(material_1.TableRow, { style: { display: (additionalColumns && !openAdditionalColumns) ? 'none' : 'table-row' } },
                                    react_1.default.createElement(material_1.TableCell, { style: { fontWeight: 'bold' } }, columnLabels
                                        ? ((_a = columnLabels[column.name]) === null || _a === void 0 ? void 0 : _a.title) || column.name
                                        : column.name),
                                    react_1.default.createElement(DataTableCell_1.default, { align: commonTypes_1.TableTextAlignment.left, entityColumns: entityColumns, treeViewLevel: props.treeViewLevel, content: tableRowData && tableRowData[column.name], column: entityColumn, entity: entity, thumbnailData: props.data.thumbnailData, entityReferencePreviews: props.data.entityReferencePreviews, id: props.id, onClickEntity: function (id) { return onClickEntity(id); } })));
                            }
                        }
                    }),
                    maxResponsiveTableColumns && additionalColumns && !openAdditionalColumns &&
                        react_1.default.createElement(material_1.TableRow, null,
                            react_1.default.createElement(material_1.TableCell, { style: { fontWeight: 'bold', cursor: 'pointer' }, colSpan: 2, align: 'center', onClick: function () { return setOpenAdditionalColumns(true); } },
                                react_1.default.createElement(material_1.Box, { className: classes.mobileTableNavigation },
                                    react_1.default.createElement(KeyboardArrowDown_1.default, null),
                                    react_1.default.createElement(react_1.default.Fragment, null, t('crude:expand'))))),
                    openAdditionalColumns &&
                        react_1.default.createElement(material_1.TableRow, null,
                            react_1.default.createElement(material_1.TableCell, { style: { fontWeight: 'bold', cursor: 'pointer' }, colSpan: 2, align: 'center', onClick: function () { return setOpenAdditionalColumns(false); } },
                                react_1.default.createElement(material_1.Box, { className: classes.mobileTableNavigation },
                                    react_1.default.createElement(KeyboardArrowUp_1.default, null),
                                    react_1.default.createElement(react_1.default.Fragment, null, t('crude:hide')))))),
                tableRowData &&
                    react_1.default.createElement(material_1.TableCell, { align: commonTypes_1.TableTextAlignment.right, className: classes.actions, style: { width: '50px' } },
                        react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } },
                            react_1.default.createElement(DataTableActions_1.default, { instancePermissions: props.data.instancePermissions, entitySchema: entitySchema, entity: entity, id: props.id, onClickEntity: function (id) { return onClickEntity(id); }, onDeleteEntity: function () { return props.reloadTableViewData && props.reloadTableViewData(); } }),
                            TableActionElement && integratedHTMLLicense &&
                                react_1.default.createElement(TableActionElement, { entity: entity, entityId: props.id, treeViewLevel: typeof props.treeViewLevel === 'number' ? props.treeViewLevel : 0, entityData: tableRowData, sharedData: sharedData }))))));
    }, [openTreeView, entityColumns, props.data, props.id, openAdditionalColumns]);
    react_1.useEffect(function () {
        var newEntityColumns = crudeSchema ? getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity) : [];
        if (JSON.stringify(entityColumns) !== JSON.stringify(newEntityColumns)) {
            setEntityColumns(newEntityColumns);
        }
    }, [crudeSchema, crudeConfig, configurableTableLicense, entity]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Row,
        ((entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.treeViewIncomingReference) && listLevelAvailable) && (react_1.default.createElement(react_1.default.Fragment, null,
            props.treeViewLevel !== 0 && react_1.default.createElement(material_1.TableRow, null),
            react_1.default.createElement(material_1.TableRow, { key: "DataTableRowTreeView" + props.id, style: {
                    backgroundColor: theme.palette.grey.A100,
                } },
                react_1.default.createElement(material_1.TableCell, { key: "DataTableCell" + props.id + "TreeView", style: openTreeView ? {
                        paddingBottom: '24px',
                        paddingTop: 0,
                        borderBottom: 0,
                    } : { paddingBottom: 0, paddingTop: 0, borderBottom: 0 }, colSpan: getTableColumns_1.default(entityColumns, entitySchema) },
                    react_1.default.createElement(material_1.Collapse, { in: openTreeView, unmountOnExit: true, component: 'div', sx: {
                            boxShadow: "" + (props.treeViewLevel && props.treeViewLevel > 0 ? '1px 1px 3px rgba(0, 0, 0, .3)' : ''),
                        } },
                        react_1.default.createElement(DataTableView_1.default, { dataViewType: commonTypes_1.DataViewType.simpleView, entity: embeddingEntityFilter.name, embeddingEntityFilter: embeddingEntityFilter, treeViewLevel: props.treeViewLevel + 1 }))))))));
};
exports.default = DataResponsiveRow;
